// i18n-aware option builders and label resolvers for age ranges, reporter types,
// and handoff institutions. Pass the `t` function from useTranslation().

export const ageRangeOptions = (t) => [
  { value: "m0_6", label: t("age.m0_6") },
  { value: "m6_12", label: t("age.m6_12") },
  ...Array.from({ length: 17 }, (_, i) => ({
    value: `y${i + 1}`,
    label: t("age.years", { count: i + 1 }),
  })),
];

export const ageRangeLabelT = (v, t) => {
  if (v === "m0_6") return t("age.m0_6");
  if (v === "m6_12") return t("age.m6_12");
  const m = /^y(\d+)$/.exec(v || "");
  if (m) return t("age.years", { count: Number(m[1]) });
  return v || "";
};

const REPORTER_KEYS = ["refugio", "voluntario", "cruz_roja", "proteccion_civil", "familiar"];
export const reporterOptions = (t) => [
  { value: "", label: t("common.select") },
  ...REPORTER_KEYS.map((k) => ({ value: k, label: t(`reporter.${k}`) })),
];
export const reporterLabelT = (v, t) => (v ? t(`reporter.${v}`, v) : "");

const INSTITUTION_KEYS = ["policia", "ambulancia", "refugio", "proteccion_civil", "cruz_roja", "otro"];
export const institutionOptions = (t) => INSTITUTION_KEYS.map((k) => ({ value: k, label: t(`institution.${k}`) }));
export const institutionLabelT = (v, t) => (v ? t(`institution.${v}`, v) : "");

export const statusLabelT = (v, t) => (v ? t(`status.${v}`, v) : "");
